export default __webpack_public_path__ + "static/media/WB_HoloDesk.0cceda01.gif";